import React from 'react';
import PropTypes from 'prop-types';
import CSSTransition from 'react-transition-group/CSSTransition';

import { SuiContainer } from '@splashthat/sui';

import { TRANSITION_TIMEOUT } from 'common/constants';

const BASE_CLASS_NAME = 'FormEditorNodeControls';

export default function FixedControls(props) {
    return (
        <CSSTransition
            in={!props.hidden}
            unmountOnExit
            mountOnEnter
            timeout={TRANSITION_TIMEOUT}
            classNames={`${BASE_CLASS_NAME}__flag-transition`}
        >
            <SuiContainer className={`${BASE_CLASS_NAME}__flag-container`}>{props.children}</SuiContainer>
        </CSSTransition>
    );
}

FixedControls.propTypes = {
    hidden: PropTypes.bool,
    children: PropTypes.arrayOf(PropTypes.node).isRequired,
};

FixedControls.defaultProps = {
    hidden: false,
};
